export type QuickTipsTranslation = {
  quickTips: string;
  uploadCv: string;
};

export const quickTipsTranslation: QuickTipsTranslation = {
  quickTips: 'Quick Tips',
  uploadCv:
    'To quickly upload your CV, simply drag and drop the file into the table area. Alternatively, you can manually sync all CVs from the system to ensure you have the most up-to-date documents available.',
};
